import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config } from "@discovery/common-dplus/lib/state";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { PremiumBannerImage } from "./optics";
import { useAds } from "../../utils/hooks/useAds";
const PremiumBannerView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const premiumBanner = Fold.preview(PremiumBannerImage, data);
    return {
        premiumBanner,
    };
};
const PremiumBanner = ({ premiumBanner, environment, }) => {
    const [configM] = useGlobalState(_Config);
    const { adsHasValidPackage, enableAds } = useAds();
    // CONFIG
    const isPaymentDisabledM = M.chain((x) => x.payments, configM);
    const disabledM = M.chain((x) => x.disabled, isPaymentDisabledM);
    const isPaymentDisabled = M.fromMaybe(disabledM, false);
    const isAdsEnabled = enableAds && !adsHasValidPackage;
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(PremiumBannerView, { read: environment, premiumBannerImageM: premiumBanner, isPaymentDisabled: isPaymentDisabled, isAdsEnabled: isAdsEnabled })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, PremiumBanner);

